import React from 'react';
import { MenuItem, MenuSeparator } from '../components/Menu';
import historyIcon from '../icons/history.svg';
import postPath from '../utils/url/postPath';
import useAppSelector from '../app/redux/useAppSelector';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const VERIFY_HISTORY_MENU_ITEM_FRAGMENT = gql(`
  fragment VerifyHistoryMenuItem_post on Post {
    id
    verificationEntries {
      id
      version
    }
    ...postPath_post
  }
`);

interface VerifyHistoryMenuItemProps {
  post: DocumentType<typeof VERIFY_HISTORY_MENU_ITEM_FRAGMENT>;
}

const VerifyHistoryMenuItem = ({ post }: VerifyHistoryMenuItemProps) => {
  const versionTo = useAppSelector((state) => state.editor.version);
  const versionFrom = post.verificationEntries.at(0)?.version ?? versionTo;

  if (versionFrom === versionTo) return null;

  return (
    <>
      <MenuSeparator />
      <MenuItem
        icon={historyIcon}
        to={`${postPath(post)}/histories/${versionFrom}/${versionTo}`}
      >
        See in history
      </MenuItem>
    </>
  );
};

export default VerifyHistoryMenuItem;
